import { Grid, Paper, Typography } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";
import React from "react";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";
import { RowInfo } from "./RowInfo";

export const CycleRow = (props) => {
  const { data, onClick } = props;
  const { alias, cycle } = data;
  const { supplyDate, cycleLabel, category } = cycle;
  const { isDark } = useThemeMode();
  
  // Format date from YYYY-MM-DD to DD/MM/YYYY
  const formattedDate = supplyDate ? supplyDate.split('-').reverse().join('/') : '';

  return (
    <Grid item xs={12}>
      <Paper
        className="on-hover"
        style={{
          cursor: "pointer",
          position: "relative",
          padding: 8,
          ...(isDark && { backgroundColor: darkPalette.altRowBg }),
        }}
        onClick={() => onClick(data)}
      >
        <Typography
          variant="caption"
          style={{
            minWidth: 50,
            padding: "4px 12px",
            backgroundColor: isDark ? darkPalette.selectedBg : blue[50],
            color: isDark ? darkPalette.accent : blue[700],
            position: "absolute",
            left: 10,
            top: -15,
            borderRadius: 8,
          }}
        >
          {alias}
        </Typography>
        <RowInfo leftLabel="Categoría" rightLabel={category} />
        <RowInfo leftLabel="Tipo de Suscripción" rightLabel={cycleLabel} />
        <RowInfo leftLabel="Fecha Programada" rightLabel={formattedDate} />
      </Paper>
    </Grid>
  );
};
